import { useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardProspectsTable from './DashboardProspectsCOMTable/DashboardProspectsCOMTable';
import Modal from '../../../../commons/Modal/Modal';
import DashboardProspectsForm from './DashboardProspectsCOMForm/DashboardProspectsCOMForm';

export default () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <DashboardLayout>
        <DashboardProspectsTable />
      </DashboardLayout>
      <Modal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside>
        <DashboardProspectsForm />
      </Modal>
    </>
  );
};
